import styled from 'styled-components';

const FooterContainer = styled.footer`
    padding-top: calc(var(--section-padding) / 2);
    padding-bottom: calc(var(--section-padding) / 2);
    background-image: url('https://i.ibb.co/PgjLpTH/subscribe.jpg');
    background-size: cover;
    position: relative;
    color: white;
    text-align: center;
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(0 0 0 / 70%);
    }
    .container {
        position: relative;
    }
    img {
        margin-bottom: 20px;
    }
    p:not(.copyright) {
        text-transform: uppercase;
        padding: 20px;
        border-bottom: 1px solid white;
        font-size: 22px;
        width: fit-content;
        margin: 20px auto;
    }
    .social-icons {
        a {
            text-decoration: none;
        }
        i {
            padding: 10px 15px;
            cursor: pointer;
            color: white;
        }
    }

    .copyright {
        margin-top: 60px;
        span {
            font-weight: bold;
            color: var(--main-color);
        }
    }
`;
export default FooterContainer;
